import { render, staticRenderFns } from "./AddCourseArticle.vue?vue&type=template&id=d8169ffc&scoped=true&"
import script from "./AddCourseArticle.vue?vue&type=script&lang=js&"
export * from "./AddCourseArticle.vue?vue&type=script&lang=js&"
import style0 from "./AddCourseArticle.vue?vue&type=style&index=0&id=d8169ffc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8169ffc",
  null
  
)

export default component.exports